import { countriesNowApiCall } from "../thirdPartyApiBase"

const citiesInCountry = async (params) => {
    const url = '/cities'
    const response = await countriesNowApiCall(url, 'POST', params);
    return response;
}

const citiesInState = async (params) => {
    const url = '/state/cities'
    const response = await countriesNowApiCall(url, 'POST', params);
    return response;
}

const stateInCountry = async (params) => {
    const url = '/states'
    const response = await countriesNowApiCall(url, 'POST', params);
    return response;
}

const countryCode = async (currentCountry) => {
    const url = '/codes'
    const params = {
        country: currentCountry
    }
    const response = await countriesNowApiCall(url, 'POST', params);
    return response?.data?.data?.code;
}

export {
    citiesInCountry, stateInCountry, citiesInState ,countryCode
}